module.exports = __webpack_public_path__ + "media/images/captive_portal/Color-One-17a1dbe3d3ebfeecd87f35d5682c0694.png";